<template>
  <q-chip
    class="q-px-none shadow-2"
    :style="chipStyle"
    :dense="dense"
    :class="{['bg-' + color + '-' + colorOffset]: true, 'q-pr-md': removable && !dense, 'q-pr-sm': removable && dense, 'q-pr-none': !removable}"
    :removable="removable"
    @remove="$emit('remove')"
  >
    <div class="flex align-center overflow-hidden">
      <q-chip
        class="q-ma-none"
        :dense="dense"
        :class="{['bg-' + color + '-' + (colorOffset - 1)]: true, ['text-' + textColor]: true, 'text-caption': small}"
        :clickable="clickable"
        :title="user.name"
        @click="$emit('click')"
      >
        <q-avatar :size="dense ? '20px': '25px'">
          <profile-image
            no-animation
            :size="dense ? '20px' : '25px'"
            :initials="user.initials"
            :profile-image="user.profile_image"
            :color="user.color"
          />
        </q-avatar>
        {{ user.name }}
      </q-chip>
      <q-btn
        v-if="!withoutBtns"
        round
        dense
        icon="mdi-email"
        size="12px"
        flat
        :color="btnColor"
        @click="goToEmail(user.email)"
      >
        <q-tooltip>
          <span class="text-caption block">Email Address</span>
          {{ user.email }}
        </q-tooltip>
      </q-btn>
      <q-btn
        v-if="userPhone && !withoutBtns"
        round
        dense
        icon="mdi-phone"
        size="12px"
        flat
        :color="btnColor"
        @click="goToPhone(userPhone)"
      >
        <q-tooltip>
          <span class="text-caption block">Phone</span>
          {{ userPhone }}
        </q-tooltip>
      </q-btn>
    </div>
  </q-chip>
</template>

<script>
import phoneAddressMixin from '../../../partials/PhoneAddressEmail'

export default {
  mixins: [
    phoneAddressMixin
  ],
  props: {
    user: {
      type: Object,
      required: true
    },
    clickable: {
      type: Boolean,
      default: false
    },
    color: {
      type: String,
      default: 'grey'
    },
    textColor: {
      type: String,
      default: 'black'
    },
    btnColor: {
      type: String,
      default: 'blue-grey'
    },
    colorOffset: {
      type: Number,
      default: 2
    },
    dense: {
      type: Boolean,
      default: false
    },
    small: {
      type: Boolean,
      default: false
    },
    withoutBtns: {
      type: Boolean,
      default: false
    },
    removable: {
      type: Boolean,
      default: false
    },
    minWidth: {
      type: String,
      default: undefined
    }
  },
  emits: ['remove', 'click'],
  computed: {
    userPhone () {
      if (!this.user.phones) {
        return null
      }
      return this.user.phones[0] ? this.user.phones[0].full_phone : null
    },
    chipStyle () {
      return this.minWidth ? { 'min-width': this.minWidth } : {}
    }
  }
}
</script>
